import { PembinaanAttributes } from "../type";
import api from "./http";

export const ApiPembinaan = {
    postPembinaan : (data:PembinaanAttributes)=>{
        return api.post(`/perizinan/pembinaan`,data)
    }
}